import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'templateName',
})
export class TemplateNamePipe implements PipeTransform {
  transform(value: string): string {
    // regex to match FC_ + fileName + _YYYY-MM-DD-HH-MM-SS
    // ^(?:FC_)? : Le début peut optionnellement commencer par FC_.
    // (.+?) : fileName: séquence de caractères (jusqu'à la partie de la date et de l'heure.)
    // (?:_\d{4}-\d{2}-\d{2}-\d{2}-\d{2}-\d{2})?$ : La fin peut optionnellement inclure une date et une heure au format _YYYY-MM-DD-HH-MM-SS.
    const regex = /^(?:FC_)?(.+?)(?:_\d{4}-\d{2}-\d{2}-\d{2}-\d{2}-\d{2})?$/;
    const match = value.match(regex);

    //if it matches return the fileName
    if (match && match[1]) {
      return match[1];
    }

    // else we return the value
    return value;
  }
}
